import type {
  ModbusMaster,
  ModbusPollResultDto,
  ModbusRegisterDto,
} from "~/types/api";
import type { ApiResponse } from "~/types/ui";
import { BaseAPI } from "./base";

export class ModbusApi extends BaseAPI {
  async getMasters(): Promise<ApiResponse<ModbusMaster[]>> {
    return this.get<ModbusMaster[]>(`modbus/masters/${this.company()}`);
  }

  async poll(
    payload: ModbusRegisterDto[],
  ): Promise<ApiResponse<ModbusPollResultDto[]>> {
    return this.post<ModbusPollResultDto[]>(`modbus/poll`, payload);
  }

  async createOrUpdateModbusRegisters(
    deveui: string,
    payload: ModbusRegisterDto[],
  ): Promise<ApiResponse<void>> {
    return this.post<void>(`modbus/register/bulk/${deveui}`, payload);
  }
}
